<template>
  <div class="availability">
    <i class="icon icon-truck1"></i>
    <slot v-if="stock">
      {{ stockNr }} Stück
    </slot>
    <!-- <slot v-if="[62, 2569, 2571, 2548].includes(parseInt(this.$store.getters.getUserGroupId))">Spätestens KW 51</slot> -->
    <slot v-if="time === 0 || time === 1">sofort versandfertig</slot>
    <slot v-else-if="time > 1 && time <= 14">in {{ time }} Tagen versandfertig</slot>
    <slot v-else>am {{ getDeliveryReadyDateString(time) }} versandfertig</slot>
  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

export default {
  name: 'Availability',
  mixins: [logicMixin],
  props: {
    stock: {
      type: Boolean,
      default: true
    },
    stockNr: {
      type: Number,
      default: 0
    },
    time: {
      type: Number,
      default: 0,
    },
  }
};
</script>

<style lang="scss" scoped>
/**
 * Availability
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Availability (Stock + Delivery time)
 * @since 2021-09-29
**/

$component: 'availability';

.#{$component} {
  display: flex;
  align-items: center;
  color: $ink-lighter;

  .icon {
    @include margin-right(map-get($spacers, 1));
    @include font-size($font-size-base * 1.1);
    color: $primary;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
